import { m3mories, nikeLanding } from './images/projects';

export const PROJECTS = [
  {
    'title': 'Archives',
    'description': 'a digital diary for your journals',
    'link': 'https://m3mories.netlify.app/',
    'imgUrl': m3mories
  },
  {
    'title': 'Nike Landing',
    'description': 'a simple landing page made with tailwindcss',
    'link': 'https://silver-jalebi.netlify.app/',
    'imgUrl': nikeLanding
  }
];
